import React, { CSSProperties, useState } from 'react';


// � 기본 스타일
export const styles: Record<string, CSSProperties> = {
  container: {
    padding: '2rem',
    display: 'flex',
    justifyContent: 'center',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', // 2열
    gap: '12px 16px',
    alignItems: 'start',
  },
  form: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    minWidth: '600px',
    width: '100%',
  },
  heading: {
    marginBottom: '1.5rem',
    fontSize: '1.5rem',
    borderBottom: '2px solid #ccc',
    paddingBottom: '0.5rem',
  },
  largeText: {
    color: "#888",
    fontSize: "1.25rem",    // 기본 16 px 기준 약 20 px
    fontWeight: 500,        // 살짝 두껍게
    margin: 0,
    textAlign: "center",
  },
  fieldGroup: {
    marginBottom: '1rem',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    fontSize: '1rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  button: {
    marginTop: '1rem',
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  disable: {
    backgroundColor: '#e0e0e0',
    color: '#9e9e9e',
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "4px",
    padding: "8px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    background: "#fafafa",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  required: {
    color: 'red',
    marginLeft: '4px',
  },
  textarea: {
    width: "100%",
    fontSize: "1rem",
    padding: "0.5rem",
    borderRadius: "6px",
    border: "1px solid #ccc",
    resize: "vertical",      // 사용자가 드래그로 늘릴 수도 있게
    overflow: "hidden",      // auto-grow 시 스크롤바 숨김
  },
  fullWidth: {
    gridColumn: '1 / -1', // 2열 전체 차지
  },
};